import useUser from '../UserProvider/useUser';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Navigate } from 'react-router-dom-v5-compat';

export function withGuard(WrappedComponent, condition) {
  return function GuardWrapper(props) {
    const { landingRoute } = useUser();
    const location = useLocation();

    if (!condition) {
      return <Navigate to={landingRoute()} state={{ from: location }} replace />;
    }
    return <WrappedComponent {...props} />;
  };
}

